import { IconProps } from '../iconProps';

export const CircleCross = ({ size, fill }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <circle
        cx='12'
        cy='12'
        r='10'
        fill={fill}
      />
      <path d='m15 9-6 6' />
      <path d='m9 9 6 6' />
    </svg>
  );
};
